export const DEFAULT_LANGUAGE = 'en_US' as const;

export const SUPPORTED_LANGUAGES = [
  DEFAULT_LANGUAGE,
  'hi_IN',
  'ml_IN',
  'ta_IN',
  'te_IN',
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const SYSTEM_LANGUAGE_MAP: Record<string, SupportedLanguage> = {
  hi: 'hi_IN',
  ml: 'ml_IN',
  ta: 'ta_IN',
  te: 'te_IN',
};

export const isSupportedLanguage = (
  language: string | null | undefined,
): language is SupportedLanguage =>
  SUPPORTED_LANGUAGES.some(supportedLanguage => supportedLanguage === language);

export const getSystemLanguage = (): string | undefined => {
  if (typeof navigator === 'undefined') {
    return undefined;
  }

  return navigator.language;
};

export const resolveLanguage = (
  cachedLanguage: string | null | undefined,
  systemLanguage?: string | null,
): SupportedLanguage => {
  if (isSupportedLanguage(cachedLanguage)) {
    return cachedLanguage;
  }

  const primaryLanguage = (systemLanguage ?? getSystemLanguage())
    ?.trim()
    .toLowerCase()
    .split(/[-_]/)[0];

  return (
    (primaryLanguage && SYSTEM_LANGUAGE_MAP[primaryLanguage]) ||
    DEFAULT_LANGUAGE
  );
};
